import { Sun, Moon } from '@phosphor-icons/react';
import { motion } from 'framer-motion';
import { useTheme } from '@/contexts/ThemeContext';

export default function ThemeToggle({ className = '' }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <motion.button
      onClick={toggleTheme}
      className={`relative w-14 h-8 rounded-full p-1 transition-colors duration-300 ${
        isDark 
          ? 'bg-white/10 hover:bg-white/15' 
          : 'bg-gray-200 hover:bg-gray-300'
      } ${className}`}
      whileTap={{ scale: 0.95 }}
      data-testid="theme-toggle"
      aria-label={isDark ? 'Activer le mode clair' : 'Activer le mode sombre'}
    >
      <motion.div
        className={`w-6 h-6 rounded-full flex items-center justify-center shadow-md transition-colors duration-300 ${
          isDark 
            ? 'bg-violet-500' 
            : 'bg-white'
        }`}
        animate={{ x: isDark ? 0 : 24 }}
        transition={{ type: 'spring', stiffness: 500, damping: 30 }}
      >
        {isDark ? (
          <Moon size={14} weight="fill" className="text-white" />
        ) : (
          <Sun size={14} weight="fill" className="text-amber-500" />
        )}
      </motion.div>
    </motion.button>
  );
}
